// import { Autocomplete, Box, TextField } from "@mui/material";
// import { LANGUAGES_ASSETS } from "common/constants";

import { useTheme } from "@mui/material"
import PropTypes from "prop-types"

SimpleSelect.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  data: PropTypes.array,
}

export default function SimpleSelect({ value, label, onChange, data = [] }) {
  const theme = useTheme()
  return (
    <select
      className={"translator-typo-content"}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{
        width: "100%",
        padding: "0.5rem",
        borderRadius: "5px",
        border: `1px solid ${theme.palette.grey.lighter3}`,
        outline: "none",
        fontSize: "1rem",
        color: theme.palette.text.lighter2,
        backgroundColor: theme.palette.background.default,
      }}
    >
      {data.map((option, index) => (
        <option
          key={index}
          value={option.value}
          className={"translator-typo-content"}
          style={{
            display: "flex",
            alignItems: "center",
          }}
          selected={value === option.value}
        >
          {option.label}
        </option>
      ))}
    </select>
  )

  // return (
  //     <Autocomplete
  //         id={`simple-select-${label}`}
  //         sx={{
  //             width: 300,

  //         }}
  //         slotProps={{
  //             popper:{
  //                 sx: {
  //                     zIndex: 9999,
  //                 }
  //             }
  //         }}
  //         size="small"
  //         options={data}
  //         getOptionLabel={(option) => option.label}
  //         renderOption={(props, option) => {
  //             const { key, ...optionProps } = props;
  //             return (
  //                 <Box
  //                     key={key}
  //                     component="li"
  //                     sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
  //                     {...optionProps}
  //                 >
  //                     <img
  //                         loading="lazy"
  //                         width="20"
  //                         srcSet={`${LANGUAGES_ASSETS}/flags/${option.value}.png 2x`}
  //                         src={`${LANGUAGES_ASSETS}/flags/${option.value}.png`}
  //                         alt=""
  //                     />
  //                     {option.label}
  //                 </Box>
  //             );
  //         }}
  //         renderInput={(params) => (
  //             <TextField
  //                 {...params}
  //                 label={label}
  //                 slotProps={{
  //                     htmlInput: {
  //                         ...params.inputProps,
  //                         autoComplete: 'new-password', // disable autocomplete and autofill
  //                     },
  //                 }}
  //             />
  //         )}
  //     />
  // )
  // return (
  //     <FormControl fullWidth>
  //         <InputLabel id={`simple-select-${label}`}>{label}</InputLabel>
  //         <Select
  //             labelId={`simple-select-${label}`}
  //             id={`select-${label}`}
  //             value={value}
  //             label={label}
  //             onChange={onChange}
  //         >
  //             {
  //                 data.map((item, index) => (
  //                     <MenuItem
  //                         key={index}
  //                         value={item.value}>
  //                         {item.label}
  //                     </MenuItem>
  //                 ))
  //             }
  //         </Select>
  //     </FormControl>
  // )
}
